$('ul.sidelinks li a').each(function(){
    if($(this).text() == 'Skin Lightening'){
     $(this).text("Skin Brightening");
    }
});
$("button.launcher-button").click(function(){
  $('.panel-subview .list-item-title').each(function(){
      if($(this).text() == 'Signup'){
       $(this).text("Sign Up");
      }
  });
});

$('#testimonial_carousel').slick({
  autoplay: true,
  autoplaySpeed: 3000,
  dots: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: '<button class="slide-arrow prev-arrow">&#10094;</button>',
  nextArrow: '<button class="slide-arrow next-arrow">&#10095;</button>',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('#small_collection_carousel').slick({
  autoplay: true,
  autoplaySpeed: 3000,
  dots: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 900,
      settings: {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('#product_quality_carousel').slick({
  autoplay: true,
  autoplaySpeed: 3000,
  dots: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: false,
  nextArrow: false,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});